export default "__VITE_ASSET__xDYQBwCE__"